import { TableCellClassKey } from '@material-ui/core';
import { CSSProperties } from '@material-ui/core/styles/withStyles';

export const MuiTableCell: Record<TableCellClassKey, CSSProperties> = {
  root: {},
  alignCenter: {},
  alignJustify: {},
  alignLeft: {},
  alignRight: {},
  body: {},
  footer: {},
  head: {},
  paddingCheckbox: {},
  paddingNone: {},
  sizeSmall: {},
  stickyHeader: { backgroundColor: 'white' },
};
